import React from 'react';
import twMerge from 'utilities/src/twMerge';
import IconComponent from '../../../../Icon';
import { IOptionProps } from './_props';

type SearchInputProps = Pick<
  IOptionProps,
  | 'getLabelProps'
  | 'maxLength'
  | 'name'
  | 'labelPosition'
  | 'placeholder'
  | 'getInputProps'
  | 'getDropdownProps'
  | 'isOpen'
> &
  Partial<Pick<IOptionProps, 'onKeyDown' | 'rules'>> & {
    htmlFor?: string;
    register?: IOptionProps['register'] | any;
  };

export default function SearchInput({
  htmlFor,
  getLabelProps,
  maxLength,
  name,
  labelPosition,
  placeholder,
  getInputProps,
  getDropdownProps,
  isOpen,
  onKeyDown,
  register,
  rules,
}: SearchInputProps) {
  return (
    <label htmlFor={htmlFor} {...getLabelProps()}>
      <div className="outline-site-neutrals-100 z-30 mx-4 mb-4 flex items-center gap-3 rounded-md p-3 py-2 outline outline-1">
        <IconComponent iconName="Search" size="IconM" className="bg-site-neutrals-900" />
        <input
          placeholder="search"
          type="text"
          maxLength={maxLength}
          className={twMerge(
            'flex w-full select-all text-ellipsis border-none font-light text-black focus:outline-none',
          )}
          name={name}
          data-testid={name}
          {...(labelPosition === 'Top' && { placeholder })}
          {...getInputProps(
            getDropdownProps({
              preventKeyAction: isOpen,
              'aria-autocomplete': 'both',
              onKeyDown,
              ...{
                ...(register &&
                  register(name, {
                    ...rules,
                  })),
              },
            }),
          )}
        />
      </div>
    </label>
  );
}
